// @flow

//
// React
//
import React from 'react';

//
// Type
//
import { type CellRendererProps } from '../../../../../lib/trix-web-components-table';

//
// Material UI
//
import TableCell from '@mui/material/TableCell';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import { makeStyles } from '@mui/styles';

//
// Styles
//
const useStyles = makeStyles(theme => ({
    root: {
        // take width of the content
        width: '1px',
        whiteSpace: 'nowrap',
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            cursor: 'pointer',
        },
    }
}));

//
// Props
//
type Props = CellRendererProps & {
    //
    // Callbacks
    //
    onClick?: () => void,

    //
    // Data
    //
    value: any,
};

//
// Component
//
const PropertyMandatoryCellRenderer = (props: Props) => {
    //
    // Hooks
    //
    const classes = useStyles();

    return (
        <TableCell 
            padding="normal" 
            className={classes.root}
        >
            {(props.value) ? 
                (
                    <CheckCircleOutlineOutlinedIcon />
                ) :
                (
                    <></>
                ) 
            }
        </TableCell>
    );
};
export default PropertyMandatoryCellRenderer;
